import React from 'react';
import { StatusBadge } from 'react-covideo-common';
import { CONNECTION_TYPES } from './constants';

interface ConnectionChipProps {
  type: CONNECTION_TYPES;
}

export const ConnectionChip = ({ type }: ConnectionChipProps) => {
  switch (type) {
    case CONNECTION_TYPES.CONNECTED:
      return <StatusBadge text={'CONNECTED'} variant='success' />;
    case CONNECTION_TYPES['NOT CONNECTED']:
      return <StatusBadge text={'NOT CONNECTED'} variant='error' />;
    case CONNECTION_TYPES.EXPIRED:
      return <StatusBadge text={'EXPIRED'} variant='gray' />;
    default:
      return null;
  }
};
